import script from "./resultPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./resultPreview.vue?vue&type=script&setup=true&lang=js"

import "./resultPreview.vue?vue&type=style&index=0&id=3c038965&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c038965"]])

export default __exports__